import { makeObservable, observable, action } from 'mobx';
import SettingsRequests from 'Utils/Requests/SettingsRequests';
import ProcessProgress from 'Stores/models/processProgress';
import { ShowAlert } from "Utils/CommonFunctions";

class MigrationData {
    migrationNeeded = false;
    migrationInProcess = false;
    migrationFirstStarted = false;
    currentMigratonName = '';
    currentProgress = new ProcessProgress();
    totalProgress = new ProcessProgress();
    completedWithError = null;
}

class MigrationStore {
    migration = new MigrationData();
    migrationLoading = false;
    startMigrationInProcess = false;

    constructor() {
        makeObservable(this, {
            migration: observable.ref,
            migrationLoading: observable,
            startMigrationInProcess: observable
        });
    }

    SetMigrationState = action((/** @type {WebMigrationStatus} */ state) => {
        let migrationState = new MigrationData();

        migrationState.migrationNeeded = state.migrationNeeded;
        migrationState.migrationInProcess = state.migrationInProcess;
        migrationState.migrationFirstStarted = state.migrationFirstStarted;
        migrationState.currentMigratonName = state.currentMigratonName;
        migrationState.currentProgress.current = state.currentProgress.current;
        migrationState.currentProgress.total = state.currentProgress.total;
        migrationState.totalProgress.current = state.totalProgress.current;
        migrationState.totalProgress.total = state.totalProgress.total;
        migrationState.completedWithError = state.completedWithError;

        if (this.migration.completedWithError == false && migrationState.completedWithError) {
            ShowAlert('error', 'Миграция завершилась с ошибками. Передайте информацию об ошибках в протоколе в службу техподдержки.');
        }
        else if (this.migration.migrationInProcess && migrationState.migrationInProcess == false) {
            ShowAlert('success', 'Миграция успешно завершилась.');
        }

        this.migration = migrationState;
    });

    StartMigration = action(() => {
        if (this.startMigrationInProcess === true)
            return;

        this.startMigrationInProcess = true;

        SettingsRequests.StartMigration()
            .then(action((values) => this.SetMigrationState(values)))
            .finally(action(() => this.startMigrationInProcess = false));
    });
}

export default new MigrationStore();